import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://kakobuypolska.com";

const findsJsonLd = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "Najlepsze Kakobuy Finds 2026",
  description: "Przegląd najpopularniejszych produktów znalezionych przez społeczność Kakobuy w 2026 roku.",
  url: `${siteUrl}/kakobuy-finds`,
  isPartOf: {
    "@type": "WebSite",
    name: "Kakobuy Spreadsheet Polska",
    url: siteUrl,
  },
};

export default function KakobuyFindsPage() {
  const finds = [
    { name: "Nike Dunk Low", category: "Shoes", rating: "4.9", price: "~280 zł" },
    { name: "Travis Scott x Jordan", category: "Shoes", rating: "4.8", price: "~450 zł" },
    { name: "Supreme Box Logo", category: "Hoodies/Sweaters", rating: "4.7", price: "~180 zł" },
    { name: "Palace Ark Air", category: "Hoodies/Sweaters", rating: "4.6", price: "~200 zł" },
    { name: "North Face Nuptse", category: "Jackets", rating: "4.9", price: "~320 zł" },
    { name: "Stone Island Soft Shell", category: "Jackets", rating: "4.8", price: "~380 zł" },
    { name: "Chrome Hearts Ring", category: "Accessories", rating: "4.5", price: "~150 zł" },
    { name: "Goyard Card Holder", category: "Bags", rating: "4.7", price: "~120 zł" },
  ];

  const [filter, setFilter] = useState("All");
  const filtered = filter === "All" ? finds : finds.filter((f) => f.category === filter);

  return (
    <div className="min-h-[100dvh] flex flex-col">
      <JsonLd data={findsJsonLd} />
      <Navbar />
      <main className="flex-1 pt-20">
        <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                Najlepsze Kakobuy Finds
              </h1>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                Przegląd najpopularniejszych produktów znalezionych przez społeczność Kakobuy w 2026 roku.
              </p>
            </div>

            {/* Filters */}
            <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
              {["All", "Shoes", "Hoodies/Sweaters", "Jackets", "Accessories", "Bags"].map((cat) => (
                <button
                  key={cat}
                  onClick={() => setFilter(cat)}
                  className={`px-4 py-2 text-sm rounded-full border transition-colors whitespace-nowrap ${
                    filter === cat
                      ? "bg-primary-500 text-background-50 border-primary-500"
                      : "bg-background-50 text-foreground-700 border-background-300 hover:border-primary-300"
                  }`}
                >
                  {cat === "All" ? "Wszystkie" : cat}
                </button>
              ))}
            </div>

            {/* Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {filtered.map((item, i) => (
                <div
                  key={i}
                  className="bg-background-100 rounded-xl p-4 border border-background-200/60 hover:border-primary-300/40 transition-all"
                >
                  <div className="aspect-square rounded-lg bg-background-200/50 mb-3 flex items-center justify-center">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
                      <i className="ri-shopping-bag-3-line text-2xl" />
                    </div>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">{item.name}</h3>
                  <p className="text-xs text-foreground-500 mb-2">{item.category}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-medium text-accent-600">{item.rating} / 5</span>
                    <span className="text-xs font-medium text-primary-600">{item.price}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-10">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm font-medium px-6 py-3 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                Zobacz więcej w Kakobuy Spreadsheet
                <i className="ri-external-link-line" />
              </a>
            </div>

            <div className="text-center mt-4">
              <Link to="/" className="text-sm text-primary-500 hover:underline">
                &larr; Wróć na stronę główną
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}